import { createDateFormat, generateApiUrl, generateLang } from "@/shared/utils";

/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { v4 as uuid } from "uuid";
import { pathOr } from "ramda";

export const getCenterExecute = async (code) => {
  try {
    const url = generateApiUrl(["kanoon", "v2", "centerExecute"], [code]);
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);

    return {
      id: pathOr(null, ["id"], data),
      companyName: pathOr("", ["company_name"], data),
      template: {
        id: pathOr(null, ["template", "id"], data),
        name: pathOr("", ["template", "name"], data),
      },
      assessmentPlan: {
        id: pathOr(null, ["assessment_plan", "id"], data),
        name: pathOr(null, ["assessment_plan", "name"], data),
      },
      candidate: {
        total: pathOr(0, ["candidate", "total"], data),
        absent: pathOr(0, ["candidate", "absent"], data),
        hasParvandehCount: pathOr(
          0,
          ["candidate", "has_parvandeh_count"],
          data
        ),
      },
      assessor: {
        total: pathOr(0, ["assessor", "total"], data),
        absent: pathOr(0, ["assessor", "absent"], data),
        hasParvandehCount: pathOr(0, ["assessor", "has_parvandeh_count"], data),
      },
      centerExecuteCase: {
        total: pathOr(0, ["center_execute_case", "total"], data),
        notStartCount: pathOr(
          0,
          ["center_execute_case", "not_start_count"],
          data
        ),
      },
      roomCount: pathOr(null, ["room_count"], data),
      personShowCompleteData: pathOr(
        null,
        ["person_show_complete_data", "caption"],
        data
      ),
      createdBy: pathOr(null, ["created_by"], data),
      createdAt: createDateFormat(pathOr("", ["created_at", "jalali"], data)),
    };
  } catch (error) {
    throw error;
  }
};
export const getCenterExecuteV1 = async (id) => {
  try {
    const url = generateApiUrl(["kanoon", "centerExecute"], [id]);
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const getPermissions = pathOr([], ["data", "permissions"], response);
    let company = pathOr(null, ["company"], data);
    company = company
      ? {
          id: pathOr(null, ["code"], company),
          caption: pathOr("", ["name"], company),
        }
      : null;

    let term = pathOr(null, ["term"], data);
    term = term
      ? {
          termId: pathOr(null, ["id"], term), // TODO: user for activity post service, remove this id after change services to version 2
          id: pathOr(null, ["code"], term),
          caption: pathOr("", ["caption"], term),
        }
      : null;

    let template = pathOr(null, ["template"], data);
    template = template
      ? {
          id: pathOr(null, ["id"], template),
          caption: pathOr("", ["caption"], template),
        }
      : null;

    let assessmentPlan = pathOr(null, ["assessment_plan"], data);
    assessmentPlan = assessmentPlan
      ? {
          id: pathOr(null, ["id"], assessmentPlan),
          caption: pathOr("", ["name"], assessmentPlan),
        }
      : null;

    let personShowCompleteData = pathOr(
      null,
      ["person_show_complete_data"],
      data
    );
    personShowCompleteData = personShowCompleteData
      ? {
          id: pathOr(null, ["id"], personShowCompleteData),
          caption: pathOr("", ["caption"], personShowCompleteData),
        }
      : null;

    let centerExecuteType = pathOr(null, ["center_execute_type"], data);
    centerExecuteType = centerExecuteType
      ? {
          id: pathOr(null, ["id"], centerExecuteType),
          caption: pathOr("", ["caption"], centerExecuteType),
        }
      : null;

    let createReportMethod = pathOr(
      null,
      ["report_card_production_method"],
      data
    );
    createReportMethod = createReportMethod
      ? {
          id: pathOr(null, ["id"], createReportMethod),
          caption: pathOr("", ["caption"], createReportMethod),
        }
      : null;

    let indicatorVerificationStatus = pathOr(
      null,
      ["indicator_verification_method"],
      data
    );
    indicatorVerificationStatus = indicatorVerificationStatus
      ? {
          id: pathOr(null, ["id"], indicatorVerificationStatus),
          caption: pathOr("", ["caption"], indicatorVerificationStatus),
        }
      : null;
    let competencyScoring = pathOr(null, ["competency_scoring_method"], data);
    competencyScoring = competencyScoring
      ? {
          id: pathOr(null, ["id"], competencyScoring),
          caption: pathOr("", ["caption"], competencyScoring),
        }
      : null;
    let competencySuggestionValueMethod = pathOr(
      null,
      ["competency_suggestion_value_method"],
      data
    );
    competencySuggestionValueMethod = competencySuggestionValueMethod
      ? {
          id: pathOr(null, ["id"], competencySuggestionValueMethod),
          caption: pathOr("", ["caption"], competencySuggestionValueMethod),
        }
      : null;

    let status = pathOr(null, ["status"], data);
    status = status
      ? {
          id: pathOr(null, ["id"], status),
          caption: pathOr("", ["caption"], status),
        }
      : null;

    const candidateSearchWithNationalCode = pathOr(
      true,
      ["candidate_search_with_national_code"],
      data
    );
    const executivePersonSearchWithNationalCode = pathOr(
      true,
      ["executive_person_search_with_national_code"],
      data
    );
    const sendSmsToExecutive = pathOr(true, ["send_sms_to_executive"], data);
    const sendSmsToCandidate = pathOr(true, ["send_sms_to_candidate"], data);
    const executivePersonTermFilter = pathOr(
      [],
      ["executive_person_term_filter"],
      data
    );
    const description = pathOr(null, ["description"], data);

    const getData = {
      id: pathOr(null, ["id"], data),
      code: pathOr(null, ["code"], data),
      title: pathOr("", ["caption"], data),
      company,
      term,
      template,
      assessmentPlan,
      startDate: pathOr("", ["start_date", "gregorian"], data),
      floatingByStartTime: !!pathOr(0, ["begin_center_time", "id"], data),
      startDelay: pathOr(0, ["start_delay"], data),
      personShowCompleteData,
      centerExecuteType,
      createReportMethod,
      indicatorVerificationStatus,
      competencyScoring,
      competencySuggestionValueMethod,
      hasVoiceRecording: pathOr(false, ["has_voice_recording"], data),
      hasWashup: pathOr(false, ["has_washup"], data),
      hasSample: pathOr(false, ["has_sample"], data),
      status,
      candidateSearchWithNationalCode,
      executivePersonSearchWithNationalCode,
      sendSmsToExecutive,
      sendSmsToCandidate,
      executivePersonTermFilter,
      description,
    };
    return { getData, getPermissions };
  } catch (error) {
    throw error;
  }
};
export const addCenterExecute = async ({
  title,
  companyCode,
  termCode,
  assessmentPlanId,
  startDate,
  floatingByStartTime,
}) => {
  try {
    const url = generateApiUrl(["kanoon", "centerExecutes"]);
    const payload = {
      caption: title,
      company_code: companyCode,
      term_code: termCode,
      assessment_plan_id: assessmentPlanId,
      start_date: startDate,
      begin_center_time: floatingByStartTime,
    };
    const response = await httpService.post(url, payload);
    const data = pathOr(null, ["data", "data"], response);
    const item = {
      id: pathOr(null, ["id"], data),
      code: pathOr(null, ["code"], data),
    };
    const message = pathOr(null, ["data", "message"], response);

    return { message, item };
  } catch (error) {
    throw error;
  }
};
export const updateCenterExecute = async ({
  id,
  title,
  startDate,
  floatingByStartTime,
  personShowCompleteDataId,
  centerExecuteTypeId,
  createReportMethodId,
  indicatorVerificationStatusId,
  competencyScoringId,
  competencySuggestionValueMethodId,
  hasVoiceRecording,
  hasWashup,
  hasSample,
  candidateSearchWithNationalCode,
  executivePersonSearchWithNationalCode,
  sendSmsToExecutive,
  sendSmsToCandidate,
  executivePersonTermFilter,
  description,
}) => {
  try {
    const url = generateApiUrl(["kanoon", "centerExecute"], [id]);
    const payload = {
      caption: title,
      start_date: startDate,
      begin_center_time: floatingByStartTime,
      is_person_show_complete_data: personShowCompleteDataId,
      center_execute_type_id: centerExecuteTypeId,
      report_card_production_method_id: createReportMethodId,
      indicator_verification_method_id: indicatorVerificationStatusId,
      competency_scoring_method_id: competencyScoringId,
      competency_suggestion_value_method_id: competencySuggestionValueMethodId,
      has_voice_recording: hasVoiceRecording,
      has_washup: hasWashup,
      has_sample: hasSample,
      candidate_search_with_national_code: candidateSearchWithNationalCode,
      executive_person_search_with_national_code:
        executivePersonSearchWithNationalCode,
      send_sms_to_executive: sendSmsToExecutive,
      send_sms_to_candidate: sendSmsToCandidate,
      executive_person_term_filter: executivePersonTermFilter,
      description,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const deleteCenterExecute = async (centerExecuteId) => {
  try {
    const url = generateApiUrl(["kanoon", "centerExecute"], [centerExecuteId]);
    const response = await httpService.delete(url);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const duplicateCenterExecute = async (centerExecuteCode) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteDuplicate"],
      [centerExecuteCode]
    );
    const response = await httpService.post(url);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const getAllCenterExecutePerson = async (
  centerExecuteId,
  page = 1,
  getPerPage = 10
) => {
  try {
    const queryString = { page, per_page: getPerPage };
    const url = generateApiUrl(
      ["kanoon", "center_execute_person"],
      [centerExecuteId],
      queryString
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const total = pathOr(0, ["total"], data);
    const count = pathOr(0, ["count"], data);
    const totalPages = pathOr(0, ["total_pages"], data);
    const currentPage = pathOr(1, ["current_page"], data);
    const perPage = pathOr(10, ["per_page"], data);
    const items = pathOr([], ["result"], data);

    return { total, count, totalPages, currentPage, perPage, items };
  } catch (error) {
    throw error;
  }
};
export const setCenterExecuteAbsent = async (
  centerExecuteId,
  candidateId,
  absentReason
) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "center_execute_absent"],
      [centerExecuteId, candidateId]
    );
    const payload = {
      is_absent: 1,
      absent_description: absentReason,
    };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const setCenterExecuteExport = async (centerExecuteId) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteExport"],
      [centerExecuteId]
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const message = pathOr(null, ["data", "message"], response);

    // handle download export file
    const fileLink = document.createElement("a");
    fileLink.href = data;
    fileLink.setAttribute("download", "");
    fileLink.click();

    return { message };
  } catch (error) {
    throw error;
  }
};
export const setParvandehSetAbsent = async (centerExecuteId, id) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "parvandeh_set_absent"],
      [centerExecuteId, id]
    );
    const response = await httpService.patch(url);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const getCenterExecuteCase = async (id) => {
  try {
    const url = generateApiUrl(["kanoon", ""], [id]);
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);

    return {
      id: pathOr(null, ["id"], data),
      centerExecuteName: pathOr("", ["center_execute", "caption"], data),
      termCaption: pathOr("", ["term", "caption"], data),
      acParvandehNumber: "255",
      room: "اتاق 6",
    };
  } catch (error) {
    throw error;
  }
};
export const changeAssessor = async (
  caseId,
  assessorParvandehCode = null,
  secondAssessorParvandehCode = null
) => {
  try {
    const url = generateApiUrl(["kanoon", "v2", "changeAssessor"], [caseId]);
    const payload = {
      parvandeh_code: assessorParvandehCode,
      second_assessor_parvandeh_code: secondAssessorParvandehCode,
    };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const setStartDelay = async (centerExecuteCode, startDelay) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "center_execute_start_delay"],
      [centerExecuteCode]
    );
    const payload = { start_delay: startDelay };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const setAssessmentPlan = async (
  centerExecuteCode,
  assessmentPlanId
) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteAssessmentPlan"],
      [centerExecuteCode]
    );
    const payload = { assessment_plan_id: assessmentPlanId };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const getCenterExecuteCaseCompetencies = async (caseId) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "v2", "allCenterExecuteCaseCompetencies"],
      [caseId]
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const items = data.map((item) => {
      return {
        id: pathOr(null, ["id"], item),
        text: pathOr("", ["name"], item),
        description: pathOr("", ["description"], item),
        hasScore: pathOr(false, ["has_score"], item),
        evidenceErrorCount: pathOr(0, ["evidence_error_count"], item),
      };
    });
    return { items };
  } catch (error) {
    throw error;
  }
};
export const getCenterExecuteCasePersons = async (centerExecuteId, caseId) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "v2", "centerExecuteCasePersons"],
      [centerExecuteId, caseId]
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);

    const assessorData = pathOr(null, ["assessors", "first"], data);
    const secondAssessorData = pathOr(null, ["assessors", "second"], data);
    const assessorFullName = pathOr("", ["full_name"], assessorData);
    const secondAssessorFullName = pathOr(
      "",
      ["full_name"],
      secondAssessorData
    );
    // generate assessor data
    const assessor = {
      id: pathOr(null, ["person_center_execute_code"], assessorData),
      name: secondAssessorData
        ? `${assessorFullName} ${generateLang([
            "and",
          ])} ${secondAssessorFullName}`
        : assessorFullName,
      type: generateLang(["assessor"]),
      images: secondAssessorData
        ? [
            pathOr("", ["avatar_address"], assessorData),
            pathOr("", ["avatar_address"], secondAssessorData),
          ]
        : [pathOr("", ["avatar_address"], assessorData)],
    };

    // generate candidate data
    const candidateData = pathOr(null, ["candidate"], data);
    const candidate = {
      id: pathOr(null, ["person_center_execute_code"], candidateData),
      name: pathOr(null, ["full_name"], candidateData),
      type: generateLang(["candidate"]),
      images: [pathOr("", ["avatar_address"], candidateData)],
    };

    // generate case status data
    const caseStatus = {
      id: pathOr(null, ["case_status", "id"], data),
      caption: pathOr("", ["case_status", "name"], data),
    };

    // generate executive Role Id
    const executiveRoleId = pathOr(
      null,
      ["current_user_center_execute_role", "executive_role_id"],
      data
    );

    // generate exercise data
    const exercise = {
      name: pathOr("", ["exercise", "name"], data),
      description: pathOr("", ["exercise", "description"], data),
    };

    const getIsIndicatorVerificationMethodByAssessor =
      pathOr(1, ["indicator_verification_method", "id"], data) === 2;
    const getIsCompetencyScoringMethodByAssessor =
      pathOr(1, ["competency_scoring_method", "id"], data) === 2;
    const getHasVoiceRecording = pathOr(false, ["has_voice_recording"], data);
    const getHasSample = pathOr(false, ["has_sample"], data);

    return {
      assessor,
      candidate,
      caseStatus,
      executiveRoleId,
      exercise,
      getIsIndicatorVerificationMethodByAssessor,
      getIsCompetencyScoringMethodByAssessor,
      getHasVoiceRecording,
      getHasSample,
    };
  } catch (error) {
    throw error;
  }
};
export const setCompetencyIndicatorStatus = async ({
  centerExecuteId,
  caseId,
  competencyId,
  indicatorId,
  statusId,
}) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteCaseCompetencyIndicator"],
      [centerExecuteId, caseId, competencyId, indicatorId]
    );
    const payload = { status: statusId };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const setComputeCompetencyRecommendedScore = async (
  centerExecuteId,
  caseId,
  competencyId
) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "computeCompetencyRecommendedScore"],
      [centerExecuteId, caseId, competencyId]
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const score = pathOr(null, ["score"], data);

    return { score };
  } catch (error) {
    throw error;
  }
};
export const setComputeCompetencyOverview = async ({
  centerExecuteId,
  caseId,
  caseStatusId,
  candidateOverallScoreId,
  strengthAndDevelopment,
  exerciseSummary,
}) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteCompetencyOverview"],
      [centerExecuteId, caseId]
    );
    const payload = {
      case_status: caseStatusId,
      score: candidateOverallScoreId,
      strength_development_area: strengthAndDevelopment,
      overall: exerciseSummary,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const getCenterExecuteCaseCompetenciesIndicators = async (
  centerExecuteId,
  caseId,
  competencyId
) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "v2", "centerExecuteCaseCompetenciesIndicators"],
      [centerExecuteId, caseId, competencyId]
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const indicators = pathOr([], ["indicators"], data);
    const indicatorsData = indicators.map((indicator) => {
      const uniqueId = uuid();
      const evidences = pathOr(null, ["evidences"], indicator);
      const evidenceErrorCount = evidences.filter((evidence) =>
        pathOr(null, ["error"], evidence)
      ).length;
      return {
        uniqueId,
        id: pathOr("", ["id"], indicator),
        caption: pathOr("", ["caption"], indicator),
        code: pathOr(null, ["code"], indicator),
        statusId: pathOr(0, ["status"], indicator),
        value: pathOr(1, ["value"], indicator),
        hasError: !!evidenceErrorCount,
        errorsCount: evidenceErrorCount,
        evidences: evidences.map((evidence) => {
          return {
            id: pathOr(null, ["id"], evidence),
            evidenceDataId: pathOr(null, ["evidence_data_id"], evidence),
            caption: pathOr("", ["caption"], evidence),
            error: pathOr(null, ["error"], evidence),
            isSelect: pathOr(false, ["is_select"], evidence),
            behavioralWitness: pathOr("", ["sample"], evidence),
          };
        }),
      };
    });

    const caseCompetency = pathOr(null, ["case_competency"], data);
    const caseCompetencyData = {
      competencyId: pathOr(null, ["competency_id"], caseCompetency),
      finalScoreId: pathOr(null, ["score"], caseCompetency),
      recommendedScore: pathOr(null, ["score_suggest"], caseCompetency),
      description: pathOr("", ["description"], caseCompetency),
    };
    return { indicatorsData, caseCompetencyData };
  } catch (error) {
    throw error;
  }
};
export const setCenterExecuteCaseCompetencyIndicatorEvidence = async ({
  centerExecuteId,
  caseId,
  competencyId,
  indicatorId,
  evidenceId,
  errorCode,
  errorDescription,
  behavioralWitness,
  isSelect,
}) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteCompetencyIndicatorEvidenceId"],
      [centerExecuteId, caseId, competencyId, indicatorId, evidenceId]
    );
    const payload = {
      error_code: errorCode,
      error_description: errorDescription,
      sample: behavioralWitness,
      status: +isSelect,
    };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const removeEvidenceData = async (evidenceDataId) => {
  try {
    const url = generateApiUrl(["kanoon", "evidenceDataId"], [evidenceDataId]);
    const response = await httpService.delete(url);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const removeEvidenceDataLog = async (
  evidenceDataId,
  centerExecuteId
) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "evidenceHistoryLog"],
      [evidenceDataId]
    );
    const payload = { is_enable: 0, center_execute_id: +centerExecuteId };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const editCenterExecuteCaseCompetency = async ({
  centerExecuteId,
  caseId,
  competencyId,
  recommendedScore,
  finalScoreId,
  description,
}) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteCaseCompetency"],
      [centerExecuteId, caseId, competencyId]
    );
    const payload = {
      score_suggest: recommendedScore,
      score: finalScoreId,
      description,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const getCenterExecuteCaseOverview = async (centerExecuteId, caseId) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "v2", "centerExecuteCaseOverview"],
      [centerExecuteId, caseId]
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);

    const competenciesItems = pathOr([], ["competencies"], data);
    const competencies = competenciesItems.map((competency) => {
      return {
        caption: pathOr("", ["nickname"], competency),
        score: pathOr(null, ["score"], competency),
        description: pathOr("", ["final_description"], competency),
      };
    });

    const exerciseData = pathOr(null, ["exercise"], data);
    const exercise = {
      candidateOverallScoreId: pathOr(0, ["score"], exerciseData),
      strengthAndDevelopment: pathOr(
        "",
        ["strength_development_area"],
        exerciseData
      ),
      exerciseSummary: pathOr("", ["overall"], exerciseData),
    };

    return { competencies, exercise };
  } catch (error) {
    throw error;
  }
};
export const setCenterExecuteState = async (centerExecuteId, statusId) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteState"],
      [centerExecuteId]
    );
    const payload = { status: statusId };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const removeCenterExecuteReport = async (centerExecuteCode) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteReport"],
      [centerExecuteCode]
    );
    const response = await httpService.delete(url);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const rebuildCenterExecuteReports = async (centerExecuteCode) => {
  try {
    const url = generateApiUrl(["kanoon", "rebuildReport"]);
    const payload = {
      resource: "center_execute",
      resource_code: centerExecuteCode,
    };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const rebuildCenterExecuteReport = async (
  centerExecuteCode,
  centerExecutePersonId
) => {
  try {
    const url = generateApiUrl(["kanoon", "rebuildReport"]);
    const payload = {
      resource: "center_execute",
      resource_code: centerExecuteCode,
      center_execute_person_id: centerExecutePersonId,
    };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const getCenterExecuteExercises = async (centerExecuteId) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteExercises"],
      [centerExecuteId]
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const getPermissions = pathOr(null, ["data", "permissions"], response);
    const items = data.map((item, index) => {
      const enable = pathOr(false, ["enable"], item);
      const exercisePrerequisite =
        enable && index ? pathOr("", ["name"], data[index - 1]) : "";

      return {
        id: pathOr(null, ["id"], item),
        name: pathOr("", ["name"], item),
        enable,
        exercisePrerequisite,
      };
    });

    return { items, getPermissions };
  } catch (error) {
    throw error;
  }
};
export const setCenterExecuteExercisePrerequisite = async (
  centerExecuteId,
  exerciseId,
  addValue
) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteExercises"],
      [centerExecuteId]
    );
    const payload = {
      exercise_id: exerciseId,
      add: addValue,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const setChangeGroupStatus = async (statusId, filters) => {
  try {
    const url = generateApiUrl(["kanoon", "centerExecutesChangeState"]);
    const payload = {
      status: statusId,
      filters,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const setIncompleteCompletion = async (centerExecuteCode) => {
  try {
    const url = generateApiUrl(["kanoon", "incompleteCompletionCenterExecute"]);
    const payload = {
      center_execute_code: centerExecuteCode,
    };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const getCenterExecuteScoreExcel = async (extraQueryString) => {
  try {
    const url =
      generateApiUrl(["kanoon", "center_execute_score_excel"]) +
      extraQueryString;
    const response = await httpService.get(url);
    const link = pathOr(null, ["data", "data"], response);
    const message = pathOr(null, ["data", "message"], response);

    return { link, message };
  } catch (error) {
    throw error;
  }
};
export const rebuildAllReports = async () => {
  try {
    const url = generateApiUrl(["kanoon", "kanoon_rebuild_all_reports"]);
    const response = await httpService.patch(url);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
